import { Button, TextField, Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginSchema } from '../Validations/login_validation';
import axiosInstance from '../util/axios_instance';
import { Helmet } from 'react-helmet-async';
function Login() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [postData, setPostData] = useState(
        {
            email: '',
            password: ''
        }
    );

    const handleChange = (event) => {
        const { name, value } = event.target;
        setPostData({
            ...postData,
            [name]: value,
        });
    };

    const login = async (e) => {
        e.preventDefault();
        try {
            await loginSchema.validate(postData, { abortEarly: false });
            setErrors({});
            const response = await axiosInstance.post(`${BACKEND_HOST}/user/sign_in`,
                postData,
                {
                    withCredentials: true
                });
            if (response.status === 200) {
                navigate('/journals');
            }
        } catch (validationErrors) {
            const formattedErrors = {};
            validationErrors.inner.forEach((error) => {
                formattedErrors[error.path] = error.message;
            })
            setErrors(formattedErrors);
        }
        finally {
            console.log("called log in");
        }
    }

    return (
        <div>
            <Helmet>
                <title>Early Access - capsuleme.io</title>
                <meta name='description' content='Join our early access program and be the first to experience our platform' />
            </Helmet>
            <form onSubmit={login}>
                <Box display="flex"
                    flexDirection={"column"}
                    width="50vw" // Set width to 50% of the viewport width
                    alignItems={'center'}
                    justifyContent={'center'}
                    margin={'auto'}
                    marginTop={5}
                    padding={3}
                    borderRadius={5}
                    boxShadow={"5px 10px 10px #ccc"}
                    sx={{
                        ":hover": {
                            boxShadow: "10px 10px 20px #ccc",
                        }
                    }}>
                    <Typography variant='h2' padding={3} textAlign={'center'}>Login</Typography>
                    <TextField
                        margin='normal'
                        variant='outlined'
                        name='email'
                        sx={{ width: '75%' }}
                        value={postData.email}
                        onChange={handleChange}
                        placeholder='Email'></TextField>
                    {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                    <TextField
                        margin='normal'
                        type='password'
                        variant='outlined'
                        name='password'
                        sx={{ width: '75%' }}
                        value={postData.password}
                        onChange={handleChange}
                        placeholder='Password'></TextField>
                    {errors.password && <div style={{ color: 'red' }}>{errors.password}</div>}
                    <Button sx={{
                            marginTop: 3,
                            borderRadius: 1, // squared corners
                            width: '50%'     // take up to 50% of Box width
                        }} variant='contained' type='submit'>Login</Button>
                    <Button sx={{
                            marginTop: 3,
                            borderRadius: 1, // squared corners
                            width: '50%'     // take up to 50% of Box width
                        }} onClick={() => { navigate("/signup") }}>Sign Up</Button>
                </Box>
            </form>
        </div>
    )
}

export default Login;
